export type SOUND_ACTIVE_TYPES = 'MAIN' | 'LEFT' | 'RIGHT' | 'MELODY' | 'METRONOME';
export type SoundParametersActiveConfiguration = {
  // False negative here
  // eslint-disable-next-line no-unused-vars
  [ActiveType in SOUND_ACTIVE_TYPES]: boolean;
}
export const defaultActives: SoundParametersActiveConfiguration = {
  'MAIN': true,
  'LEFT': true,
  'RIGHT': true,
  'MELODY': true,
  'METRONOME': false,
}

export type SOUND_VOLUME_TYPES = 'LEFT' | 'RIGHT' | 'MELODY' | 'METRONOME';
export type SoundParametersVolumeConfiguration = {
  // False negative here
  // eslint-disable-next-line no-unused-vars
  [ActiveType in SOUND_VOLUME_TYPES]: number;
}
export const defaultVolumes: SoundParametersVolumeConfiguration = {
  'LEFT': 100,
  'RIGHT': 85,
  'MELODY': 70,
  'METRONOME': 70,
}

export const SOUND_LABELS = new Map<SOUND_ACTIVE_TYPES|SOUND_VOLUME_TYPES, string>([
  ['MAIN', 'Global'],
  ['LEFT', 'Main Gauche'],
  ['RIGHT', 'Main Droite'],
  ['MELODY', 'Mélodie'],
  ['METRONOME', 'Metronome'],
])
export const SOUND_ICONS = new Map<SOUND_ACTIVE_TYPES|SOUND_VOLUME_TYPES, string>([
  ['MAIN', 'mdi-volume-high'],
  ['LEFT', 'mdi-hand-left'],
  ['RIGHT', 'mdi-hand-right'],
  ['MELODY', 'mdi-music-note'],
  ['METRONOME', 'mdi-metronome'],
])

export class SoundParameters {
  readonly editableVolumes = ['LEFT', 'RIGHT', 'MELODY', 'METRONOME'] as SOUND_VOLUME_TYPES[];
  readonly defaultVolumes: SoundParametersVolumeConfiguration;

  volumes: SoundParametersVolumeConfiguration;
  actives: SoundParametersActiveConfiguration;

  constructor(actives: SoundParametersActiveConfiguration, volumes: SoundParametersVolumeConfiguration) {
    this.actives = {...actives};

    this.defaultVolumes = {...volumes};
    this.volumes = {...volumes};
  }
}
export const defaultSoundParameters = new SoundParameters(defaultActives, defaultVolumes)
